import { jsxs, jsx } from 'react/jsx-runtime';
import '../../../utils/index_orig/index.esm.js';
import '../../../utils/theme/theme-provider/index.esm.js';
import { useLocalization } from '@shared-ui/localization-context';
import '../../../button/button/index.esm.js';
import 'react';
import '../../../button/paging-button/index.esm.js';
import { EGDSPagingNextButton } from '../../../button/paging-next-button/index.esm.js';
import { EGDSPagingPrevButton } from '../../../button/paging-prev-button/index.esm.js';
import styles from '../../../styles/uitk-egds-calendar.css';
import { classNames } from '../../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSCalendarNavigationControls = ({
  canAdvance,
  canRetreat,
  children,
  className,
  enabled,
  navType,
  numMonths = 0,
  stretchy = false,
  handleNextClicked,
  handlePrevClicked
}) => {
  const isInset = navType === 'inset';
  const rootClasses = getClassNameList({
    'uitk-cal-controls': true,
    'uitk-cal-controls-stretchy': stretchy,
    className
  });
  const l10n = useLocalization();
  const parentClasses = getClassNameList({
    'uitk-cal-controls-parent-inset-single': isInset && numMonths === 1,
    'uitk-cal-controls-parent-outset-single': !isInset && numMonths === 1,
    'uitk-cal-controls-parent-outset-multi': !isInset && numMonths > 1,
    'uitk-cal-controls-parent-stretchy': stretchy
  });
  const buttonClasses = getClassNameList('uitk-cal-controls-button', {
    'uitk-cal-controls-button-inset': isInset && numMonths === 1,
    'uitk-cal-controls-button-inset-multi': isInset && numMonths > 1,
    'uitk-cal-controls-button-outset': !isInset
  });
  const prevButtonClasses = getClassNameList(buttonClasses, 'uitk-cal-controls-button-prev');
  const nextButtonClasses = getClassNameList(buttonClasses, 'uitk-cal-controls-button-next');
  const previousUID = Math.random().toString(36).substring(7);
  const nextUID = Math.random().toString(36).substring(7);
  if (enabled) {
    return jsxs("div", {
      className: rootClasses,
      children: [jsx("div", {
        className: prevButtonClasses,
        children: jsx(EGDSPagingPrevButton, {
          "data-stid": "uitk-calendar-navigation-controls-previous-button",
          disabled: !canRetreat,
          iconId: previousUID,
          iconTitle: l10n.formatText('calendar.prevMonthButton.a11yLabel'),
          onClick: handlePrevClicked
        })
      }), jsx("div", {
        className: nextButtonClasses,
        children: jsx(EGDSPagingNextButton, {
          "data-stid": "uitk-calendar-navigation-controls-next-button",
          disabled: !canAdvance,
          iconId: nextUID,
          iconTitle: l10n.formatText('calendar.nextMonthButton.a11yLabel'),
          onClick: handleNextClicked
        })
      }), jsx("div", {
        className: parentClasses,
        children: children
      })]
    });
  }
  const childrenClassNames = getClassNameList(className, 'uitk-cal-controls-empty');
  EGDSCalendarNavigationControls.displayName = 'EGDSCalendarNavigationControls';
  return jsx("div", {
    className: childrenClassNames,
    children: children
  });
};
export { EGDSCalendarNavigationControls };